import React from 'react';
import {
    Filter, BooleanField, DeleteButton, DateField, RichTextField, SimpleShowLayout, Show,
    ShowButton, SimpleList, BooleanInput, List, Edit, Create, Datagrid, ReferenceField,
    TextField, EditButton, ReferenceInput, required, SelectInput, SimpleForm, TextInput
} from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import constants from './../shared/constants';
import { useMediaQuery, useTheme } from '@mui/material';

//Utils
import Validators from './renderFields/validatorsFields';

const FaqFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar" source="title" alwaysOn />
    </Filter>
);

export const FaqList = (props) => {
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    return (
        <List {...props} title="Listar FAQS" filters={<FaqFilter />}>
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.title}
                    secondaryText={record => new Date(record.createdAt).toLocaleDateString()}
                />
            ) : (
                <Datagrid>
                    <TextField source="id" />
                    <TextField source="title" label="Título" />
                    <RichTextField source="content" label="Descripción" />
                    <BooleanField source="state" label="Estado" />
                    <EditButton />
                    <ShowButton />
                    <DeleteButton />
                </Datagrid>
            )}
        </List>
    );
};

const FaqTitle = ({ record }) => {
    return <span>FAQS {record ? `"${record.title}"` : ''}</span>;
};

export const FaqCreate = (props) => (
    <Create {...props} title="Crear FAQS">
        <SimpleForm>
            <TextInput source="title" label="Título" validate={[Validators.required]}/>
            <RichTextInput source="content" label="Descripción"  validate={[Validators.required]} isRequired={true} validation={{ required: true }}/>
            <BooleanInput source="state" label="Estado" defaultValue={true}/>
        </SimpleForm>
    </Create>
);

export const FaqEdit = (props) => (
    <Edit title={<FaqTitle />} {...props}>
        <SimpleForm>
            <TextInput source="id" disabled/>
            <TextInput source="title" label="Título" validate={[Validators.required]}/>
            <RichTextInput source="content" label="Descripción" validate={[Validators.required]} isRequired={true} validation={{ required: true }}/>
            <BooleanInput source="state" label="Estado"/>
        </SimpleForm>
    </Edit>
);

export const FaqShow = (props) => (
    <Show title={<FaqTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="title" label="Título"/>
            <RichTextField source="content" label="Descripción"/>
            <BooleanField source="state" label="Estado"/>
            <DateField label="Fecha de Actualización" source="updatedAt" />
            <DateField label="Fecha de Publicación" source="createdAt" />
        </SimpleShowLayout>
    </Show>
);
